export default "__VITE_ASSET__B3csz8$O__"